<template>
    <div class="prepay">
        <h3>预付款管理</h3>
        <el-form :inline="true" class="demo-form-inline" v-loading="loading" size="mini">
            <el-form-item label="预付款单">
                <el-input v-model="filter.id" placeholder="预付款单"></el-input>
            </el-form-item>
            <el-form-item label="合同编号">
                <el-input v-model="filter.contractId" placeholder="订单号"></el-input>
            </el-form-item>
            <el-form-item label="备注码">
                <el-input v-model="filter.code" placeholder="备注码"></el-input>
            </el-form-item>
            <el-form-item label="预付状态">
                <el-select v-model="filter.status">
                    <el-option v-for="val,key in status" :key="key" :value="key" :label="val"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="户名">
                <el-input v-model="filter.accountName" placeholder="户名"></el-input>
            </el-form-item>
            <el-form-item label="付款账号">
                <el-input v-model="filter.cardNo" placeholder="付款账号"></el-input>
            </el-form-item>
            <el-form-item label="到账时间">
                <el-date-picker v-model="filter.arrivalTimeStart" type="datetime" placeholder="选择日期时间" align="center">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="至">
                <el-date-picker v-model="filter.arrivalTimeEnd" type="datetime" placeholder="选择日期时间" align="center">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button-group>
                    <el-button type="primary" @click="search" size="mini">查询</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>
        <el-table :data="list" size="mini">
            <el-table-column prop="id" label="预付款单号"></el-table-column>
            <el-table-column prop="contractId" label="合同编号"></el-table-column>
            <el-table-column prop="userAName" label="甲方昵称"></el-table-column>
            <el-table-column prop="accountName" label="户名"></el-table-column>
            <el-table-column prop="cardNo" label="付款账号"></el-table-column>
            <el-table-column prop="bank" label="开户行"></el-table-column>
            <el-table-column prop="prePayPending" label="预付金额"></el-table-column>
            <el-table-column prop="createTime" label="预付时间"></el-table-column>
            <el-table-column prop="preNoteCode" label="转账备注码"></el-table-column>
            <el-table-column label="转账备截图">
                <template slot-scope="scope"><a target="_blank" :href="scope.row.rechargeProveUrl">查看截图</a></template>
            </el-table-column>
            <el-table-column label="到账金额" width="200">
                <template slot-scope="scope">
                    <template v-if="scope.row.status !== 1">
                        {{scope.row.prePayArrival}}
                    </template>
                    <el-input v-else type="text" size="mini" v-model="scope.row.prePayArrival">
                        <el-button slot="append" :disabled="scope.row.prePayArrival <= 0" size="mini" @click="update(scope.row, 2)">确定</el-button>
                    </el-input>
                </template>
            </el-table-column>
            <el-table-column prop="arrivalTime" label="到账时间"></el-table-column>
            <el-table-column label="预付状态">
                <template slot-scope="scope">{{status[scope.row.status]}}</template>
            </el-table-column>
            <el-table-column prop="auditNote" label="驳回原因"></el-table-column>
            <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                    <el-button-group size="mini">
                        <el-button size="mini" :disabled="scope.row.status !== 1" @click="showRejectDialog(scope.row)">驳回</el-button>
                        <el-button size="mini" :disabled="scope.row.status !== 1" @click="$router.push(`/prepay/detail/${scope.row.id}`)">修改</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <br/>
        <div style="float: right">
            <el-pagination background layout="prev, pager, next" :page-size="20" @current-change="i=>pageNum=i" :page-count="pageNum" :total="total" ref="pagination">
            </el-pagination>
        </div>
        <el-dialog title="驳回原因" :visible.sync="rejectDialogShow">
            <el-form>
                <el-form-item>
                    <el-input type="textarea" :rows="5" v-model="auditNote">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="rejectDialogShow = false">取 消</el-button>
                <el-button type="primary" @click="update(auditData, 3)">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import api from '../api'
const {
    prepay
} = api

import moment from 'moment'

export default {
    name: "prepay",
    data() {
        return {
            loading: true,
            list: [],
            total: 0,
            pageNum: 1,
            limit: 20,
            filter: {
                id: '',
                contractId: '',
                status: '1',
                code: '',
                accountName: '',
                cardNo: '',
                arrivalTimeStart: '',
                arrivalTimeEnd: '',
            },
            status: {
                // '0': '待预付',
                '1': '待审核',
                '2': '已确认',
                '3': '已驳回',
                '4': '全部',
            },
            rejectDialogShow: false,
            auditData: {},
            auditNote: '',
        };
    },
    watch: {
        pageNum() {
            this.fetch()
        }
    },
    methods: {
        async fetch() {
            this.loading = true;
            let {
                id,
                contractId,
                status,
                code,
                accountName,
                cardNo,
                arrivalTimeStart,
                arrivalTimeEnd,
            } = this.filter
            let obj = {
                id,
                contractId,
                status,
                code,
                accountName,
                cardNo,
                arrivalTimeStart,
                arrivalTimeEnd,
                pageNum: this.pageNum,
                limit: this.limit,
            }

            if (obj.arrivalTimeStart && obj.arrivalTimeEnd) {
                obj.arrivalTimeStart = Date.parse(obj.arrivalTimeStart)
                obj.arrivalTimeEnd = Date.parse(obj.arrivalTimeEnd)
            }
            if (arrivalTimeStart && !arrivalTimeEnd) {
                obj.arrivalTimeEnd = Date.now()
                obj.arrivalTimeStart = Date.parse(obj.arrivalTimeStart)
            }

            let res = await prepay.list(obj);
            this.list = res.data.data;
            this.loading = false;
            this.total = res.data.pageinfo.totalCount
        },
        async update(item, status) {
            let obj = {
                id: item.id,
                status: status,
                auditNote: '',
                prepayArrival: 0,
            }

            if (status === 2) {
                obj.prepayArrival = item.prePayArrival;
            } else if (status === 3) {
                obj.auditNote = this.auditNote;
            }

            let res = await prepay.updateStatus(obj)

            let {
                code
            } = res.data
            if (code === 200) {
                this.$message.success('更新数据成功')
                this.auditNote = '';
            }
            this.rejectDialogShow = false
            this.fetch()
        },
        async search() {
            this.$refs.pagination.internalCurrentPage = 1
            this.pageNum = 1
            this.fetch()
        },
        showRejectDialog(item) {
            this.auditData = item
            this.rejectDialogShow = true
        },
    },
    mounted() {
        this.fetch();
    }
};
</script>
<style>
.user-list {}
</style>


// WEBPACK FOOTER //
// src/views/finance/prepay.vue